export default {
  path: '/opensource',
  name: 'QualcommOpenSource',
  component: () => import('@/projects/Qualcomm/outerPges/openSource'),
  children: []
}
